export const url = "https://dev.mycontor.ir/";
export const baseUrl = `${url}api`;

export const urls = {
  verfiyCode: "V1/Login/Code/Send",
  Login: "V1/Login",
  User: "V1/User",
  GetUserBills: "V1/User/BillParameter",
  DeleteUserBill: "V1/User/BillParameter/",
  UpdateBillParam: "V1/User/BillParameter/",
  getHistory: "V1/User/Payments",
  Payment: "V1/User/Payment/Request",
  BillStatus: "V1/User/Bill/",
  GetBillHistory: "V1/User/Bills?bill_id=",
  Inquire: "V1/Bill/Inquiry",
  GetReminder: "V1/Bill/Inquiry/Reminders",
  getFAQ: "V1/Base/Category?content_name=faq",
};
